import type { User as FirebaseUser } from "firebase/auth";
import { action, computed, makeObservable, observable } from "mobx";
import type SuperUserModel from "../users/SuperUserModel";
import type { Stores } from "./stores";

export default class SessionStore {
  @observable authUser: FirebaseUser | null = null;
  _googleAutocompleteToken: google.maps.places.AutocompleteSessionToken | null =
    null;
  viewedPlans = observable.map<string, boolean>();

  // api: Api | null = null;

  constructor(private stores: Stores) {
    makeObservable(this);
  }

  @action async setAuthUser(user: FirebaseUser | null) {
    this.authUser = user;
  }

  @action clearUser() {
    this.authUser = null;
  }

  @computed get isLoggedIn() {
    return !!this.authUser && !!this.superUser;
  }

  @computed get isRegistered() {
    return !!this.superUser?.data.email;
  }

  @computed get isDev(): boolean {
    return this.isLoggedIn && (this.superUser?.data?.isDev ?? false);
  }

  @computed get superUser(): SuperUserModel | undefined {
    if (this.authUser) {
      return this.stores.superUsersStore.byId.get(this.authUser.uid);
    }
    return undefined;
  }

  @computed get uid() {
    return this.authUser?.uid ?? "";
  }

  @computed get superUserUid() {
    return this.superUser?.uid;
  }

  @computed get hasInternet() {
    return true; // TODO - fix proper checks
  }

  getGoogleAutocompleteToken(
    Constructor: new () => google.maps.places.AutocompleteSessionToken,
  ): google.maps.places.AutocompleteSessionToken {
    const token = this._googleAutocompleteToken || new Constructor();

    if (!this._googleAutocompleteToken) {
      this._googleAutocompleteToken = token;
    }

    return this._googleAutocompleteToken;
  }
}
